"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderGroup = exports.RenderOption = void 0;
var React = __importStar(require("react"));
var RenderOption = function (_a) {
    var value = _a.value, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement("option", { value: value, disabled: disabled }, label));
};
exports.RenderOption = RenderOption;
var RenderGroup = function (group) {
    return (React.createElement("optgroup", { label: group.group }, group.options.map(function (option) { return (React.createElement(RenderOption, { key: "grp_".concat(group.group, "_opt_").concat(option.value), label: option.label, value: option.value, disabled: option.disabled })); })));
};
exports.RenderGroup = RenderGroup;
//# sourceMappingURL=renders.js.map